var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 33,
    viewBox: "0 0 50 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.753 8.1998V4.9998H34.5892V1.7998H21.0479V4.9998H25.8841V8.1998",
    stroke: "#4376FB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44154 18.5998H5.57258V13.7998H1.70361V26.5998H5.57258V21.7998H9.44154",
    stroke: "#4376FB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2631 13V17H41.3613V10.4744C41.3613 9.6608 40.5769 9 39.6116 9H20.0724C19.6091 9 19.1622 9.156 18.8343 9.4336L14.2786 13.8H11.3769C10.4096 13.8 9.44238 14.6 9.44238 15.4V25C9.44238 25.8144 10.4116 26.6 11.3769 26.6H14.2786L18.8362 30.9688C19.1641 31.2448 19.6091 31.4 20.0724 31.4H32.5063C32.9696 31.4 33.4145 31.2448 33.7424 30.9688L40.8477 24.9832C41.1776 24.7064 41.3604 24.332 41.3604 23.9408V21.8H44.2621V25.8H48.1311V13H44.2631Z",
    stroke: "#4376FB",
    strokeWidth: 2.0077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6876 19.4L23.9496 28.2L26.8513 21H22.0151L26.8513 13H31.6876L26.8513 19.4H31.6876Z",
    fill: "#4376FB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.5aa47364589849e5db28c5f0246eba49.svg";
export { ForwardRef as ReactComponent };